import React from 'react';
import SEO from '../SEO/SEO';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import NewsletterSignup from '../NewsletterSignup/NewsletterSignup';
import logo from '../Images/SmartLifeChoice-Logo.png';
import '../Styles/reset.css';
import '../Styles/utils.css';
import '../Styles/layout.css';

function AboutPage() {
    return (
        <div>
            <SEO
                title="About SmartLifeChoice - Evidence-Based Health & Fitness Guidance"
                description="Learn about SmartLifeChoice's mission to provide evidence-based health and fitness information. Discover our commitment to integrity, science, and empowering your wellness journey."
                url="/about"
                keywords="about smartlifechoice, health blog, fitness experts, evidence-based wellness, health information"
            />
            <Header />

            <main className="main">
                <div className="container">
                    <section className="about-section">
                        <h1 className="section-title">About: SmartLifeChoice</h1>

                        <div className="about-intro" style={{
                            maxWidth: '900px',
                            margin: '0 auto 4rem auto',
                            textAlign: 'center'
                        }}>
                            <div className="about-logo" style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '2rem 0 3rem 0',
                                gap: '1rem'
                            }}>
                                <img src={logo} alt="SmartLifeChoice" style={{
                                    maxHeight: '120px',
                                    width: 'auto'
                                }} />
                                <h2 style={{
                                    fontSize: '2rem',
                                    fontWeight: 700,
                                    color: 'var(--color-primary)',
                                    margin: 0
                                }}>SmartLifeChoice</h2>
                            </div>

                            <p style={{
                                fontSize: '1.3rem',
                                lineHeight: 1.8,
                                color: 'var(--color-gray-700)',
                                marginBottom: '3rem'
                            }}>
                                We believe that true wellness comes from the balanced integration of physical fitness,
                                proper nutrition, and mental wellbeing. Our mission is to provide evidence-based,
                                accessible information that empowers you to make informed decisions about your health.
                            </p>
                        </div>

                        <div className="about-story-section" style={{
                            backgroundColor: 'white',
                            borderRadius: 'var(--radius-lg)',
                            padding: '3rem',
                            marginBottom: '3rem',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                        }}>
                            <h2 style={{
                                fontSize: '2rem',
                                fontWeight: 700,
                                color: 'var(--color-primary)',
                                marginBottom: '1.5rem'
                            }}>Our Story</h2>
                            <p style={{
                                fontSize: '1.1rem',
                                lineHeight: 1.8,
                                color: 'var(--color-gray-700)',
                                marginBottom: '1.25rem'
                            }}>
                                SmartLifeChoice began in 2020 when a group of health professionals, fitness enthusiasts,
                                and wellness advocates came together with a common frustration: the overwhelming amount
                                of conflicting, misleading, and non-scientific health information available online.
                            </p>
                            <p style={{
                                fontSize: '1.1rem',
                                lineHeight: 1.8,
                                color: 'var(--color-gray-700)'
                            }}>
                                We set out to create a trusted resource where readers could find information that is
                                not only engaging and practical but also backed by scientific research and professional
                                expertise. Our team combines decades of experience in various health-related fields to
                                bring you content that is both reliable and applicable to your daily life.
                            </p>
                        </div>

                        <div className="about-approach-section" style={{
                            backgroundColor: 'white',
                            borderRadius: 'var(--radius-lg)',
                            padding: '3rem',
                            marginBottom: '3rem',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                        }}>
                            <h2 style={{
                                fontSize: '2rem',
                                fontWeight: 700,
                                color: 'var(--color-primary)',
                                marginBottom: '1.5rem'
                            }}>Our Approach</h2>
                            <p style={{
                                fontSize: '1.1rem',
                                lineHeight: 1.8,
                                color: 'var(--color-gray-700)',
                                marginBottom: '1.5rem'
                            }}>
                                What sets SmartLifeChoice apart is our commitment to:
                            </p>
                            <ul style={{
                                listStyleType: 'none',
                                padding: 0,
                                margin: 0
                            }}>
                                <li style={{
                                    fontSize: '1.05rem',
                                    lineHeight: 1.8,
                                    color: 'var(--color-gray-700)',
                                    marginBottom: '1rem',
                                    paddingLeft: '1.5rem',
                                    position: 'relative'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        left: 0,
                                        color: 'var(--color-accent)',
                                        fontWeight: 'bold'
                                    }}>✓</span>
                                    <strong style={{ color: 'var(--color-primary)' }}>Evidence-based content:</strong> Every article is thoroughly researched and fact-checked
                                </li>
                                <li style={{
                                    fontSize: '1.05rem',
                                    lineHeight: 1.8,
                                    color: 'var(--color-gray-700)',
                                    marginBottom: '1rem',
                                    paddingLeft: '1.5rem',
                                    position: 'relative'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        left: 0,
                                        color: 'var(--color-accent)',
                                        fontWeight: 'bold'
                                    }}>✓</span>
                                    <strong style={{ color: 'var(--color-primary)' }}>Holistic perspective:</strong> We recognize the interconnectedness of physical, mental, and nutritional health
                                </li>
                                <li style={{
                                    fontSize: '1.05rem',
                                    lineHeight: 1.8,
                                    color: 'var(--color-gray-700)',
                                    marginBottom: '1rem',
                                    paddingLeft: '1.5rem',
                                    position: 'relative'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        left: 0,
                                        color: 'var(--color-accent)',
                                        fontWeight: 'bold'
                                    }}>✓</span>
                                    <strong style={{ color: 'var(--color-primary)' }}>Practical application:</strong> We focus on actionable advice you can implement today
                                </li>
                                <li style={{
                                    fontSize: '1.05rem',
                                    lineHeight: 1.8,
                                    color: 'var(--color-gray-700)',
                                    paddingLeft: '1.5rem',
                                    position: 'relative'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        left: 0,
                                        color: 'var(--color-accent)',
                                        fontWeight: 'bold'
                                    }}>✓</span>
                                    <strong style={{ color: 'var(--color-primary)' }}>Inclusivity:</strong> Our content addresses the needs of individuals at all stages of their wellness journey
                                </li>
                            </ul>
                        </div>

                        <div className="values-section" style={{
                            backgroundColor: 'var(--color-gray-50)',
                            borderRadius: 'var(--radius-lg)',
                            padding: '4rem 3rem',
                            margin: '3rem 0'
                        }}>
                            <h2 style={{
                                fontSize: '2.5rem',
                                fontWeight: 700,
                                color: 'var(--color-primary)',
                                textAlign: 'center',
                                marginBottom: '3rem'
                            }}>Our Values</h2>

                            <div className="values-grid" style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                                gap: '2rem',
                                margin: '0'
                            }}>
                                <div className="value-item" style={{
                                    backgroundColor: 'white',
                                    padding: '2rem',
                                    borderRadius: 'var(--radius-md)',
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    cursor: 'pointer'
                                }} onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-4px)';
                                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.12)';
                                }} onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
                                }}>
                                    <h3 style={{
                                        color: 'var(--color-primary)',
                                        fontSize: '1.5rem',
                                        fontWeight: 700,
                                        marginBottom: '1rem'
                                    }}>Integrity</h3>
                                    <p style={{
                                        fontSize: '1.05rem',
                                        lineHeight: 1.7,
                                        color: 'var(--color-gray-700)'
                                    }}>We are committed to honesty, transparency, and ethical practices in all our content and recommendations.</p>
                                </div>

                                <div className="value-item" style={{
                                    backgroundColor: 'white',
                                    padding: '2rem',
                                    borderRadius: 'var(--radius-md)',
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    cursor: 'pointer'
                                }} onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-4px)';
                                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.12)';
                                }} onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
                                }}>
                                    <h3 style={{
                                        color: 'var(--color-primary)',
                                        fontSize: '1.5rem',
                                        fontWeight: 700,
                                        marginBottom: '1rem'
                                    }}>Evidence-Based</h3>
                                    <p style={{
                                        fontSize: '1.05rem',
                                        lineHeight: 1.7,
                                        color: 'var(--color-gray-700)'
                                    }}>We prioritize science and research, avoiding fads and unsubstantiated claims that can lead readers astray.</p>
                                </div>

                                <div className="value-item" style={{
                                    backgroundColor: 'white',
                                    padding: '2rem',
                                    borderRadius: 'var(--radius-md)',
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    cursor: 'pointer'
                                }} onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-4px)';
                                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.12)';
                                }} onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
                                }}>
                                    <h3 style={{
                                        color: 'var(--color-primary)',
                                        fontSize: '1.5rem',
                                        fontWeight: 700,
                                        marginBottom: '1rem'
                                    }}>Inclusivity</h3>
                                    <p style={{
                                        fontSize: '1.05rem',
                                        lineHeight: 1.7,
                                        color: 'var(--color-gray-700)'
                                    }}>We create content that respects and addresses the diverse needs, backgrounds, and goals of our readership.</p>
                                </div>

                                <div className="value-item" style={{
                                    backgroundColor: 'white',
                                    padding: '2rem',
                                    borderRadius: 'var(--radius-md)',
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    cursor: 'pointer'
                                }} onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-4px)';
                                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.12)';
                                }} onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
                                }}>
                                    <h3 style={{
                                        color: 'var(--color-primary)',
                                        fontSize: '1.5rem',
                                        fontWeight: 700,
                                        marginBottom: '1rem'
                                    }}>Empowerment</h3>
                                    <p style={{
                                        fontSize: '1.05rem',
                                        lineHeight: 1.7,
                                        color: 'var(--color-gray-700)'
                                    }}>Our goal is to provide you with the knowledge and tools to make informed decisions about your health.</p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <NewsletterSignup />
            </main>

            <Footer />
        </div>
    );
}

export default AboutPage;
